var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-xs modal-dialog-scrollable",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _c("i", { staticClass: "fa fa-gear" }),
              _vm._v(" "),
              _c("b", [_vm._v(_vm._s(_vm.$t("kanbanAttributes")))])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.board
                ? [
                    _c(
                      "ul",
                      { staticClass: "list-group" },
                      _vm._l(_vm.board.attributeDefinitions, function(def) {
                        return _c(
                          "li",
                          {
                            key: def.id,
                            staticClass: "list-group-item",
                            on: {
                              click: function($event) {
                                return _vm.edit(def)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(def.name) +
                                "\n              "
                            ),
                            _vm.canEdit
                              ? _c("div", { staticClass: "float-right" }, [
                                  _c("div", { staticClass: "btn-group" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-sm btn-primary",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.edit(def)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-sm btn-danger",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.del(def)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-dumpster"
                                        })
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.board ||
              !_vm.board.attributeDefinitions ||
              !_vm.board.attributeDefinitions.length
                ? _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("kanbanNoAttributesDefined")) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("EditModal", { ref: "editModal" })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _vm.canEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.add.apply(null, arguments)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnClose")) + "\n        "
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }